import saveToBraze from "@utils/brazeUploader";
import { getNoomSessionStorage } from "@utils/noomSessionStorage";
import { SessionStorageKey } from "@utils/constants";
import { sendTelehealthFeedbackSurveyResponse } from "src/funnels/insurance-reimbursement/apiRequests";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import {
  QNamesToQText,
  QTypes,
  whyDidYouSelectOptions,
} from "src/pages/telehealth/feedback/feedbackSurveyEnums";

// Expand multiple choice options to save their full text form
const expandTextOptions = (
  options?: string[] | object[]
): string[] | undefined => {
  return options
    ? options.map((v) => (v?.other ? v.other : whyDidYouSelectOptions[v]))
    : undefined; // Returning undefined
};

export const onCompleteTelehealthFeedbackSurvey = async () => {
  const { howWasYourVisit, whyDidYouSelect, whatWouldHaveMadeBetter } =
    getSurveyAnswers();

  const wheelConsultId = getNoomSessionStorage(
    SessionStorageKey.wheelConsultId
  );
  if (!wheelConsultId) {
    return;
  }

  sendTelehealthFeedbackSurveyResponse(wheelConsultId, "Survey_V1_March2023", {
    howWasYourVisit: {
      text: QNamesToQText.howWasYourVisit,
      type: QTypes.singleChoice,
      answer: howWasYourVisit[0], // value is single element array
    },
    whyDidYouSelect: {
      text: QNamesToQText.whyDidYouSelect,
      type: QTypes.multipleChoiceWithOtherText,
      answer: expandTextOptions(whyDidYouSelect), // ["a", "b", ... {"other": "other text"}]
    },
    whatWouldHaveMadeBetter: {
      text: QNamesToQText.whatWouldHaveMadeBetter,
      type: QTypes.openText,
      answer: whatWouldHaveMadeBetter, // value is single element array
    },
  });

  await saveToBraze({
    event: {
      event_name: "finished_telehealth_feedback_survey",
      event_data: {
        howWasYourVisit,
        whyDidYouSelect,
        whatWouldHaveMadeBetter,
      },
    },
  });
};
